<template>
  <div :class="mobileMenu ? 'enable-vertical-menu' : ''">
    <div id="layout-wrapper">
      <div class="vertical-menu mm-active">
        <div class="h-100" :class="theme == 'dark' ? 'dark' : ''">
          <div class="navbar-brand-box">
            <img :src="require(`../../../assets/images/logo-${theme}.png`)" />
          </div>

          <div id="sidebar-menu">
            <!-- 左侧导航 -->
            <Menu :theme="theme" :open-names="openItem" :active-name="activeName" accordion>
              <div v-for="item in menuItem" :key="item.path">
                <MenuItem v-show="!item.isFold" :name="item.name" :to="item.path">
                <span :class="item.icon"></span>
                {{ item.text }}
                </MenuItem>

                <Submenu v-show="item.isFold" :name="item.name">
                  <template slot="title">
                    <span :class="item.icon"></span>
                    {{ item.text }}
                  </template>
                  <MenuItem v-for="list in item.children" :key="list.path" :name="list.name" :to="list.path">
                  {{ list.text }}
                  </MenuItem>
                </Submenu>
              </div>
            </Menu>
          </div>
          <div class="over">
            <i-switch v-model="theme" :true-value="'dark'" :false-value="'light'" />
          </div>

        </div>
      </div>

      <header id="page-topbar">
        <div class="navbar-header" :class="isScrollTop ? '' : 'fixed-header'">
          <div class="d-flex align-items-left">
            <span class="iconfont icon-caidan menu" @click="mobileMenu = !mobileMenu"></span>
            <span class="iconfont full" :class="isFullscreen ? 'icon-suoxiao' : 'icon-quanping'"
              @click="screenfull"></span>
          </div>

          <div class="d-flex align-items-center">
            <div class="dropdown d-inline-block" @click="$router.push('/user/update')">
              <span class="badge-got" v-if="upFlag"></span>
              <Tooltip content="版本更新" placement="bottom">
                <Icon custom="iconfont icon-iconfontzhizuobiaozhun0254" size="22"></Icon>
              </Tooltip>
            </div>

            <div class="dropdown d-inline-block" @click="news">
              <!-- <span class="badge-got"></span> -->
              <Icon type="ios-notifications-outline" size="26"></Icon>
            </div>

            <div class="dropdown d-inline-block">
              <Dropdown trigger="click">
                <a href="javascript:void(0)">
                  <img :src="require('../../../assets/img/default_handsome.jpg')" class="avatar" alt="" />
                  <!-- click 触发
                <Icon type="ios-arrow-down"></Icon> -->
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem>
                    <div @click="$router.push('/user/info')">
                      <span class="iconfont icon-geren"></span>
                      个人信息
                    </div>
                  </DropdownItem>
                  <DropdownItem>
                    <div @click="$router.push('/user/log')">
                      <span class="iconfont icon-rizhi"></span>
                      操作日志
                    </div>
                  </DropdownItem>
                  <DropdownItem>
                    <div @click="cleanCache">
                      <span class="iconfont icon-icon-test"></span>
                      清理缓存
                    </div>
                  </DropdownItem>

                  <DropdownItem divided>
                    <div @click="exit">
                      <span class="iconfont icon-zhuxiaodenglu"></span>
                      退出登录
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
      </header>



      <div class="main-content">
        <router-view></router-view>

        <footer class="footer">
          <div class="container-fluid">
            <div class="footer-left">
              <a href="https://www.kancloud.cn/osuu234/geek-shop/2278960" target="_blank">使用手册</a>
            </div>
            <div class="footer-right">© <a href="http://shop.h234.cn" target="_blank">极客实验室</a></div>
          </div>
        </footer>
      </div>
    </div>
    <div class="menu-overlay" @click="mobileMenu = !mobileMenu"></div>
    <Notice :msg="msg"></Notice>
  </div>
</template>

<script>
  import menuItem from "./data";
  import cookie from "@/utils/store/cookie";
  import {
    getClear,
    getUpdate
  } from "@/api/admin";
  import {
    mapState,
  } from 'vuex'
  import Notice from '../../../plugins/Notice.vue';
  export default {
    components: {
      Notice
    },
    data() {
      return {
        theme: "light", //dark  light
        menuItem: [],
        activeName: "",
        openItem: [],
        mobileMenu: false,
        isFullscreen: false,
        isScrollTop: true,
        edition: "",
        upurl: "",
        upFlag: false,
        msg: ""
      };
    },
    computed: {
      ...mapState(['version']),
    },
    mounted() {
      window.addEventListener("scroll", this.scrollToTop);
      this._getUpdate()
      // this.$Notice.info({
      //   title: '官方公告',
      //   duration: 20,
      //   desc: 78877878
      // });
    },
    methods: {
      // 清理缓存
      cleanCache() {
        getClear().then(res => {
          this.$Message.success({
            background: true,
            content: res.msg,
          });
        })
      },
      // 获取列表
      _getUpdate() {
        getUpdate().then((res) => {
          if (res.data.version != this.version) {
            this.upFlag = true
          }
          this.msg = res.data.v3msg
          if (!cookie.get("isMsg")) {
            this.$store.state.isMsg = true
          }
        });
      },
      news() {
        this.$store.state.isMsg = true
      },



      // 监听屏幕滚动
      scrollToTop() {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop == 0) {
          this.isScrollTop = true;
        } else {
          this.isScrollTop = false;
        }
      },
      // 退出登录
      exit() {
        this.$Modal.confirm({
          title: "退出确认",
          content: "即将退出登录，是否继续？",
          onOk: () => {
            cookie.remove("username")
            cookie.remove("password")
            sessionStorage.removeItem("token", true);
            this.$router.push("/login");
          },
        });
      },
      // 全屏/缩小
      screenfull() {
        if (this.isFullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          }
          this.isFullscreen = false;
        } else {
          let docElm = document.documentElement;
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen();
          } else if (docElm.msRequestFullscreen) {
            docElm.msRequestFullscreen();
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen();
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen();
          }
          this.isFullscreen = true;
        }
      },
      // 导航
      navigates() {
        this.menuItem = menuItem;
        this.activeName = this.$route.name;
        if (this.$route.name.indexOf("-") != -1) {
          this.openItem.push(this.$route.name.split("-")[0]);
        }
      },
    },
    created() {
      this.navigates();
    },
    watch: {
      // 监听路由刷新
      $route: {
        handler: function (val, oldVal) {
          this.mobileMenu = false
        },
        // 深度观察监听
        deep: true,
      },
    },
  };
</script>

<style lang="less" scoped>
  @import url("../../../assets/css/theme.min.css");
  @import url("../../../assets/css/clean.css");
  @deep: ~">>>";

  @{deep}.ivu-dropdown,
  .ivu-icon {
    vertical-align: middle;
  }



  .align-items-left {
    width: 100%;
    height: 60px;
    // padding: 0 20px;
    text-align: center;
    line-height: 60px;

    span {
      width: 60px;
      font-size: 20px;
      vertical-align: middle;
    }
  }

  .badge-got {
    position: absolute;
    transform: translateX(-50%);
    transform-origin: 0 center;
    top: 12px;
    right: 5px;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    background: #ed4014;
    z-index: 10;
    box-shadow: 0 0 0 1px #fff;
  }

  .navbar-brand-box {
    width: 240px;
    height: 120px;

    img {
      margin: 0 auto;
      width: 120px;
      height: 120px;
    }
  }

  .h-100 {
    min-height: 100vh;
    position: relative;

    .over {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
  }

  @{deep}.ivu-menu-light:after {
    width: 0;
  }

  @{deep}.ivu-form-item-label {
    font-weight: 100;
    font-size: 14px;
  }
</style>